import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSub,
  DropdownMenuSubTrigger,
  DropdownMenuSubContent,
} from "@/components/ui/dropdown-menu";

import { Button } from "@/components/ui/button";
import { MoreHorizontal } from "lucide-react";

const TableActionsMenu = ({ actions = [] }) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" onClick={(e) => e.stopPropagation()}>
          <MoreHorizontal className="h-5 w-5" />
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="end" className="w-44 bg-white rounded-md shadow-md">
        {actions.map((action, index) => {
          if (action.submenu && action.submenu.length > 0) {
            return (
              <DropdownMenuSub key={index}>
                <DropdownMenuSubTrigger>{action.label}</DropdownMenuSubTrigger>
                <DropdownMenuSubContent className="bg-white rounded-md shadow-md">
                  {action.submenu.map((subAction, subIdx) => (
                    <DropdownMenuItem
                      key={subIdx}
                      onClick={subAction.onClick}
                      className={subAction.className}
                    >
                      {subAction.label}
                    </DropdownMenuItem>
                  ))}
                </DropdownMenuSubContent>
              </DropdownMenuSub>
            );
          }

          return (
            <DropdownMenuItem key={index} onClick={action.onClick} className={action.className}>
              {action.label}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default TableActionsMenu;
